/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Miniapp_NoneInputs */

const vi_shop_home_miniapp_none = /** @type {(inputs: Shop_Home_Miniapp_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini App không có khối này`)
};

/**

* @param {Shop_Home_Miniapp_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_miniapp_none = /** @type {((inputs?: Shop_Home_Miniapp_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Miniapp_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_miniapp_none(inputs)
});